import { Row, Typography, useTheme } from "@commonlibs";
import type { RoleDto } from "common/models/api/models/RoleDto";
import { useMemo } from "react";
import ResourceInfo from "ui/role/utils/ResourceInfo";
import { RoleSelectResourceImage } from "./RoleSelectLabel.styles";

interface RoleSelectLabelProps {
    role: RoleDto;
}

export default function RoleSelectLabel({ role }: RoleSelectLabelProps): JSX.Element {
    const { spacing } = useTheme();

    const { image, name } = useMemo(() => ResourceInfo.fromRole(role), [role]);

    return (
        <Row gap={spacing[2]} alignItems="center" justifyContent={"center"}>
            <RoleSelectResourceImage src={image} alt={`${name}-image`} />
            <Typography variant="body2Regular">{name}</Typography>
        </Row>
    );
}
